<script>
import EventSeries from "./EventSeries/EventSeries.vue";

export default {
    name: "EventSeriesParent",
    components: { EventSeries },
    methods: {},
    computed: {},
    mounted() {
    },
};
</script>

<template>
    <EventSeries
    />
</template>

<style scoped>

</style>
